module.exports = __webpack_public_path__ + "static/p-7-7c94f4ff41ca853aa85957f29138ff79.jpg";